// src/Components/pages/AdminLayout.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminSidebar from '../../Components/AdminSidebar';

const AdminLayout = ({ user, onLogout, activeComponent, children }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const navigate = useNavigate();

  const handleMenuClick = (menuId) => {
    // Correct navigation paths
    const routes = {
      dashboard: '/admin/dashboard',
      users: '/admin/users',
      maintenance: '/admin/maintenance',
      settings: '/admin/settings'
    };
    
    navigate(routes[menuId] || '/admin/dashboard');
  };

  return (
    <div className="admin-layout">
      <AdminSidebar 
        user={user} 
        onLogout={onLogout}
        activeTab={activeComponent}
        setActiveTab={handleMenuClick}
        sidebarCollapsed={sidebarCollapsed}
        setSidebarCollapsed={setSidebarCollapsed}
      />
      
      <main className={`admin-main-content ${sidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
        {children}
      </main>
    </div>
  );
};

export default AdminLayout;